import { subscribeChannel, publishChannel } from './channelUtils';

export function sendVehicleChanges(vehiclesChanges) {

    publishChannel('trip-vehicle-changes', vehiclesChanges);

}

export function sendUpsertVehicleChanges(vehicleChange) {

    publishChannel('trip-vehicle-changes-upsert', vehicleChange);

}

export function listenVehiclesChanges(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'trip-vehicle-changes' &&
            tipo !== 'trip-vehicle-changes-upsert'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}